// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3868":"211c9ad28f3db656","4453":"c860cf4319636da3"}[chunkId] + ".js";
};